import { render, staticRenderFns } from "./TherapeuticPlanTab.vue?vue&type=template&id=4b3e5997"
import script from "./TherapeuticPlanTab.vue?vue&type=script&lang=js"
export * from "./TherapeuticPlanTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports